import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class ReadNext extends Component {

    private static healioUrl = "https://www.healio.com";
    private cleanArticleId: string | undefined;
    private primarySpecialtyName: string | undefined;
    private primarySubSpecialtyId: string | undefined;
    private hwsHost: string | undefined;
    private visitedPagesArray: string[] | null;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.cleanArticleId = this._element.dataset.cleanArticleId;
        this.primarySpecialtyName = this._element.dataset.primarySpecName;
        this.primarySubSpecialtyId = this._element.dataset.primarySubSpecId;
        this.hwsHost = this._element.dataset.hwsHost;
        this.visitedPagesArray = null;
    }

    public async init(): Promise<void> {
        const readNextElement = this;
        $(() => {
            if (window.Visitor !== undefined && window.Visitor !== "") {
                readNextElement.loadReadNext();
            } else {
                $(window).one("globalsloaded", () => readNextElement.loadReadNext());
            }
        });

    }

    private filterAlreadyRead(this: ReadNext, value: any): any {
        if (this.visitedPagesArray && this.visitedPagesArray.includes("{" + value.url.replace("/find/", "").toUpperCase() + "}")) {
            return false;
        } else {
            return true;
        }
    }
    private filterResponse(input: any): any {
        return input.relatedItems.filter((value: any) => this.filterAlreadyRead(value));
    }

    private loadReadNext(): void {
        const readNextElement = this;
        if (typeof (window.Context) === 'undefined') {
            console.warn("window.Context is not defined. Unable to load Read Next")
            return
        }
        if (window.Visitor.isbot || window.Visitor.type === "DC") {
            return;
        }
        var visitedPages = sessionStorage.getItem("visitedPages");
        readNextElement.visitedPagesArray = visitedPages ? JSON.parse(visitedPages) : null;
        if (readNextElement.visitedPagesArray != null && window.Context?.documentid) {
            if (readNextElement.visitedPagesArray.length < 8) {
                if (!readNextElement.visitedPagesArray.includes(window.Context.documentid)) {
                    readNextElement.visitedPagesArray.push(window.Context.documentid);
                    sessionStorage.setItem("visitedPages", JSON.stringify(readNextElement.visitedPagesArray));
                }
            } else if (window.Context?.documentid) {
                readNextElement.visitedPagesArray.shift();
                readNextElement.visitedPagesArray.push(window.Context.documentid);
                sessionStorage.setItem("visitedPages", JSON.stringify(readNextElement.visitedPagesArray));
            }
        } else if (window.Context?.documentid) {
            readNextElement.visitedPagesArray = [];
            readNextElement.visitedPagesArray.push(window.Context.documentid);
            sessionStorage.setItem("visitedPages", JSON.stringify(readNextElement.visitedPagesArray));
        }

        if ($('.article__content--footer').prev().prev().is('h4')) {
            $('.article__content--footer').prev().prev().before($('#recoMobile'));
        } else {
            $('.article__content--footer').prev().before($('#recoMobile'));
        }
        if (typeof (window.contentBottom) !== "undefined") {
            var leftColumn = $(".article__left-col")
            var recoOneOffsetTop = $("#recoOne").offset()?.top
            var recoTwoOffsetTop = $("#recoTwo").offset()?.top

            var leftColumnTop = leftColumn.offset()?.top;

            var recoOneTop = leftColumnTop && recoOneOffsetTop ? recoOneOffsetTop - leftColumnTop : 0;
            var recoTwoTop = leftColumnTop && recoTwoOffsetTop ? recoTwoOffsetTop - leftColumnTop : 0;
            var tmode = "article";
            var primaryspecname = readNextElement.primarySpecialtyName;
            var primarysubspec = readNextElement.primarySubSpecialtyId;
            if (!primaryspecname || primaryspecname === "") primaryspecname = "na";
            if (!primarysubspec || primarysubspec === "") primarysubspec = "na";
            primaryspecname = primaryspecname.replace(/&#39;/g, '');
            primaryspecname = primaryspecname.replace(/ &/g, '');
            $.ajax({
                type: "GET",
                url: readNextElement.hwsHost + "/~/hws/relatedchips/" + readNextElement.cleanArticleId + "/" + tmode + "/" + primaryspecname + "/" + primarysubspec,
                success: function (msg: any): void {
                    //callback function to use filter with
                    var filteredResponse = readNextElement.filterResponse(msg.response);
                    var readNextPrimary = filteredResponse[0];
                    var readNextOne = filteredResponse[1];
                    var readNextTwo = filteredResponse[2];

                    if (readNextPrimary && readNextPrimary.url !== '' && readNextPrimary.url !== undefined) {
                        $("#recoPrimary a").attr("href", readNextPrimary.url.toString().replace(ReadNext.healioUrl, ""));
                    }

                    if (typeof (window.contentBottom) === 'function' && recoOneTop <= window.contentBottom() && readNextOne && readNextOne.url !== '' && readNextOne.url !== undefined) {
                        $("#recoOne a").html(readNextOne.title);
                        $("#recoOne a").attr("href", readNextOne.url.toString().replace(ReadNext.healioUrl, ""));
                        $("#recoOne div").removeClass("d-none");
                    }
                    if (typeof (window.contentBottom) === 'function' && recoTwoTop <= window.contentBottom() && readNextTwo && readNextTwo.url !== '' && readNextTwo.url !== undefined) {
                        $("#recoTwo a").html(readNextTwo.title);
                        $("#recoTwo a").attr("href", readNextTwo.url.toString().replace(ReadNext.healioUrl, ""));
                        $("#recoTwo div").removeClass("d-none");
                    }
                    if (!readNextOne && !readNextTwo) console.log("Read more results empty.");
                    if (readNextOne) {
                        $("#hrefMobileOne").html(readNextOne.title);
                        $("#hrefMobileOne").attr("href", readNextOne.url.toString().replace(ReadNext.healioUrl, ""));
                    }
                    if (readNextTwo) {
                        $("#hrefMobileTwo").html(readNextTwo.title);
                        $("#hrefMobileTwo").attr("href", readNextTwo.url.toString().replace(ReadNext.healioUrl, ""));
                    }
                },
                error: function () {
                    console.error("Error loading ReadNext");
                },
                timeout: 5000
            });
        }
    }

}

ComponentFactory.registerComponent("ReadNext", ReadNext);
